import { BasicComponent } from "haxt";

import "./MemberLanding.scss";
import { Router } from "../../@noxtum/router/Router";

/*
Landing page should contain information currently on the full membership card i.e.
```
Members receive annual online access to Irish Geography, the Society's peer-reviewed academic journal,
featuring original research and critical perspectives on geographical issues in Ireland and beyond.
Membership also includes a wide range of professional and community benefits, including:
- Participation in nationwide seminars, workshops, conferences, and fieldtrips;
- Opportunities to attend co-hosted events with other national bodies;
- Connection to a broad network of geographers across academia, education, policy, and practice;
- Engagement with current debates, research, and initiatives shaping geography in Ireland;
- Full Membership supports the work of the GSI while offering valuable opportunities for learning, networking, and professional development.

Membership runs for a calendar year from January - December.
```


Reduce text down to only two buttons: 

Full Membership - please select this option if you are in full time employment 
Concessionary Membership - please select this option if you are a student, unwaged or retired.

Below these include the following text: Please note membership runs on a calendar year, from January - December.
Both of the above options include access to the same level of membership benefits.

*/

export class MemberLanding extends BasicComponent<{
	page: string;
	parts: string[];
}> {
	public render() {
		return (
			<div class="MemberLanding">
				<h1>Welcome to the Geographical Society of Ireland</h1>
				<p>
					Membership of the Geographical Society of Ireland (GSI) offers a range of benefits to individuals interested in geography and related fields. Members receive annual online access to Irish Geography, the Society's peer-reviewed academic journal, featuring original research and critical perspectives on geographical issues in Ireland and beyond.
				</p>
				<p>
					Membership also includes a wide range of professional and community benefits, including:
				</p>
				<ul>
					<li>Participation in nationwide seminars, workshops, conferences, and fieldtrips;</li>
					<li>Opportunities to attend co-hosted events with other national bodies;</li>
					<li>Connection to a broad network of geographers across academia, education, policy, and practice;</li>
					<li>Engagement with current debates, research, and initiatives shaping geography in Ireland;</li>
					<li>Full Membership supports the work of the GSI while offering valuable opportunities for learning, networking, and professional development.</li>
				</ul>
				<p>
					Membership runs for a calendar year from January - December.
				</p>
				<button class="btn" type="button" onClick={() => Router.navigate("/members/renew-join")}>Join or Renew Membership</button>
			</div>
		);
	}
}
